import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-error-modal',
    templateUrl: './error-modal.component.html',
    styleUrls: ['./error-modal.component.scss']
})
export class ErrorModal {

    @Input() title = 'Errore';
    @Input() content = 'Si è verificato un errore. Riprova.';
    @Input() buttonText = 'Chiudi';

    constructor(
        public activeModal: NgbActiveModal,
    ) {}
}
